import { VIA_MCP_LABEL } from '@easyhelp/shared';
import Typography from '@mui/material/Typography';
import { Children, type ReactNode } from 'react';

/** «MCP» con l'espansione (WCAG 2.2 3.1.4 AAA, abbreviazioni): `<abbr>` con il nome per esteso. */
function McpAbbr() {
  return (
    <abbr title="Model Context Protocol" style={{ textDecoration: 'none' }}>
      MCP
    </abbr>
  );
}

/** «via MCP» come nodi: testo, con l'abbreviazione espansa. */
function ViaMcpLabel() {
  return (
    <>
      via <McpAbbr />
    </>
  );
}

/**
 * Rende i figli con ogni «via MCP» dei testi resi come `ViaMcpLabel` (#156): le frasi degli eventi restano
 * stringhe semplici da comporre e da testare, l'abbreviazione si espande solo qui.
 */
export function WithViaMcpAbbr({ children }: { children: ReactNode }) {
  return Children.map(children, (child) => {
    if (typeof child !== 'string' || !child.includes(VIA_MCP_LABEL)) return child;
    const parts = child.split(VIA_MCP_LABEL);
    return parts.flatMap((part, index) => (index === 0 ? [part] : [<ViaMcpLabel key={index} />, part]));
  });
}

/**
 * «via MCP» accanto al nome dell'autore di una nota scritta da Claude o Cursor (#156, DEC-015 decisione
 * 6): testo, non un'icona, nel colore secondario (contrasto AAA sul bianco).
 */
export function ViaMcpMark() {
  return (
    <Typography variant="body2" component="span" color="text.secondary">
      <ViaMcpLabel />
    </Typography>
  );
}
